
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "17",
    "viewBox": "0 0 18 17"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFF",
                        "d": "M5.228 5.34h7.647v.864H5.228v-.863zm0 3.39h7.647v.864H5.228v-.863zm-.005 3.391h3.722v.864H5.223v-.864zM2.185 5.125h1.34V6.42h-1.34V5.125zm0 3.39h1.34V9.81h-1.34V8.515zm-.005 3.39h1.34v1.296H2.18v-1.296zm5.633 4.229H1.17c-.218 0-.284-.171-.284-.383V3.288c0-.211.066-.383.284-.383h12.914c.218 0 .284.171.284.383v7.218c0 .232.195.42.434.42.24 0 .435-.188.435-.42V2.484c0-.239-.2-.432-.446-.432H.463c-.247 0-.447.193-.447.432v14.071c0 .239.2.432.447.432h7.35c.244 0 .442-.191.442-.426 0-.236-.198-.427-.442-.427zm8.056-3.173c.077-.078.126-.183.126-.3 0-.238-.2-.431-.447-.431-.12 0-.23.046-.31.121l-.001.002-.008.008-3.21 3.105-1.29-1.247c-.08-.078-.192-.127-.316-.127-.247 0-.446.193-.446.432 0 .119.05.227.13.305l1.29 1.247-.009.008.632.611.009-.008.009.008.632-.61-.01-.009 3.219-3.115z",
                        "transform": "translate(-377 -737) translate(255 724) translate(122 13)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  